import React, { useContext, useState } from 'react'
import { Grid } from '@mui/material'

import { useNavigate } from 'react-router-dom'
import { isMobile } from 'react-device-detect'
import {
  LaakariButton,
  InfoContainer,
  ShadowContainer,
  SubHeaderH2,
  ContainerHeaderH1
} from '../../components/styled/uiComponents'
import { UserContext } from '../../context'
import { isCurrentAnyMemberOfFMAOrOtherOrganization, isStudent } from '../../utils/membershipChecks'
import MobileTitle from './MobileTitle'
import Divider from './Divider'

const PersonalInfo = () => {
  const { user } = useContext(UserContext)
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(!isMobile)
  user?.employments?.find((job: any) => job.els_paatoimi === true)
  const isMember = isCurrentAnyMemberOfFMAOrOtherOrganization(user)
  const studentMember = isStudent(user)

  const handleNavigateEdit = () => {
    navigate('/updateInfo')
  }

  return (
    <>
      <Divider id='info' isMobile={isMobile} />
      <InfoContainer>
        <Grid container>
          <Grid container direction='row' justifyContent='space-between' alignItems='center'>
            {isMobile ? (
              <MobileTitle isOpen={isOpen} setIsOpen={setIsOpen} title='Tietoni' />
            ) : (
              <>
                <Grid item xs={12} md={9} lg={10}>
                  <ContainerHeaderH1>Perustiedot</ContainerHeaderH1>
                </Grid>
                <Grid item xs={12} md={3} lg={2} style={{ textAlign: 'right' }}>
                  {(isMember || studentMember) && user && !isMobile && (
                    <LaakariButton onClick={handleNavigateEdit}>Muokkaa tietoja</LaakariButton>
                  )}
                </Grid>
              </>
            )}
          </Grid>
          {isOpen && (
            <Grid item xs={12}>
              <ShadowContainer>
                <Grid
                  container
                  direction={isMobile ? 'column' : 'row'}
                  alignItems='space-between'
                  spacing={3}>
                  <>
                    <Grid item xs={12} md={3}>
                      <SubHeaderH2>Henkilötiedot</SubHeaderH2>
                      <h3>Sukunimi</h3>
                      <p>{user?.lastname}</p>

                      <h3>Etunimet</h3>
                      <p>{user?.firstname}</p>

                      <h3>Kutsumanimi</h3>
                      <p>{user?.nickname}</p>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <SubHeaderH2>Yhteystiedot</SubHeaderH2>

                      <h3>Matkapuhelin</h3>
                      <p>{user?.mobilephone}</p>

                      <h3>Sähköposti</h3>
                      <p>{user?.emailaddress1}</p>
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <SubHeaderH2>Postiosoitteet</SubHeaderH2>

                      <h3>Postiosoite</h3>
                      <p>{user?.address1_line1}</p>
                      {user?.address1_line2?.trim() ? <p>{user.address1_line2}</p> : null}
                      {user?.address1_line3?.trim() ? <p>{user.address1_line3}</p> : null}
                      <p>{user?.address1_postalcode}</p>
                      <p>{user?.address1_city}</p>
                      <p>{user?.address1_country_els_koodinnimi}</p>
                      <p>{user?.address1_country?.els_koodinnimi}</p>

                      <h3>Postituskieli</h3>
                      <p>{user?.postikieli?.value}</p>

                      <h3>Osoitteen luovutus</h3>
                      <p>{user?.markkinoinninesto?.value}</p>
                    </Grid>
                  </>
                  <Grid item xs={12}>
                    {(isMember || studentMember) && user && isMobile && (
                      <LaakariButton onClick={handleNavigateEdit}>Muokkaa tietoja</LaakariButton>
                    )}
                  </Grid>
                </Grid>
              </ShadowContainer>
            </Grid>
          )}
        </Grid>
      </InfoContainer>
    </>
  )
}

export default PersonalInfo
